import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-signup-route\"></div>",{ moduleName: "mewe/pods/components/routable/signup-route/template.hbs" })